import Box from '@mui/material/Box';
import { Spinner } from './icons';

export function PageLoader({ size = 40 }: { size?: number }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 240,
        flex: 1,
      }}
    >
      <Spinner sx={{ width: size, height: size }} />
    </Box>
  );
}
